import { Component, OnInit, ViewChild, ViewContainerRef, OnDestroy, Output, ElementRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator'; //NOSONAR - Deprecation has been applied during migration. To remove warning, control has to be upgraded as per current version of Angular Library.
import { MatTableDataSource } from '@angular/material/table'; //NOSONAR - Deprecation has been applied during migration. To remove warning, control has to be upgraded as per current version of Angular Library.
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { MenuContextualService } from '@app/shared/services/menu-contextual.service';
import { AlertService } from '@app/shared/services/alert.service';
import { LoaderService } from '@app/shared/services/loader.service';
import { TableLazyLoadEvent } from 'primeng/table';
import { ConstantsService } from '@app/common/constants.service';
import { EncryptService } from '@app/shared/services/encrypt.service';
import { IdentityUserDto, Tile, UserService } from '@app/shared/services/user.service';
import { CommonService } from '@app/shared/services/CommonService';
import { AddUsersComponent } from './add-users/add-users.component';
import { ColDef, GridApi, GridOptions, GridReadyEvent, IColumnToolPanel, RowModelType, SideBarDef } from 'ag-grid-community';
import { AgGridConfigurationService } from '@app/shared/services/ag-grid-configuration.service';
import { AgGridSelectAllComponent } from '@app/shared/shared-components/ag-grid-select-all/ag-grid-select-all.component';
import { PagerService } from '@app/shared/services/pager.service';
import { RoleService } from '@app/shared/services/role.service';
import { filter, firstValueFrom } from 'rxjs';
import { SliderComponent } from '@app/shared/shared-components/slider/slider.component';
import { AgGridModule } from 'ag-grid-angular';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { CommonModule } from '@angular/common';
import { UserAuthService } from '@app/shared/services/user-auth.service';
import { MatTooltipModule } from '@angular/material/tooltip';
@Component({
    standalone: true,
    selector: 'app-user-management-main',
    templateUrl: './user-management-main.component.html',
    styleUrls: ['./user-management-main.component.scss'],
    imports: [AddUsersComponent, SliderComponent, AgGridModule, MatSelectModule, MatMenuModule, MatDividerModule, FormsModule, ReactiveFormsModule, MatIconModule, MatChipsModule, CommonModule, MatTooltipModule]
})
export class UserManagementMainComponent implements OnInit, OnDestroy {
  @ViewChild(AddUsersComponent, { static: false }) addUserComponent: AddUsersComponent;
   @ViewChild('gridUser', { static: false }) gridUser!: ElementRef;
  users: any;
  loading = false;
  editmode = false;
  displayedColumns: string[] = ['userName', 'firstName', 'lastName', 'email', 'action'];
  errorMessage = '';
  userInfo = new Array<IdentityUserDto>();
  userData = new MatTableDataSource<IdentityUserDto>(); //NOSONAR - Deprecation has been applied during migration. To remove warning, control has to be upgraded as per current version of Angular Library.
  @ViewChild(MatPaginator) paginator: MatPaginator; //NOSONAR - Deprecation has been applied during migration. To remove warning, control has to be upgraded as per current version of Angular Library.
  sliderWidth = '35%';
  tenantId: string;
  forTenant = false;
  roleList: any = [];
  userRoles: any = [];
  editText: string;
  enableSlider = false;
  totalRecords = 0;
  first = 0;
  rows = 12;
  pageSize = 10;
  rowsPerPage;
  currentPage = 1;
  lastPage = true;
  sortOrder: string = null;
  pageSkipNumber = 0;
  dataMap: Tile[] = [];
  pageMax = 10;
  searchQuery = '';
  headerToolTip: string;
  showSearchButton = true;
  @Output() public editRowInfo: IdentityUserDto;
  pager: { totalItems: number; currentPage: number; pageSize: number; totalPages: number; startPage: number; endPage: number; startIndex: number; endIndex: number; pages: number[]; };
  dataSource: any;
  cols: any[];
  isCyberWise: boolean;
  isValidRole = true;
  currentUserId = '';
  showFilter = true;
  jsonFilterInfo: string = null;
  agGridColDef: any; // ag grid col defination
  agGridRowData: any; // ag grid row data
  rowModelType: RowModelType = 'serverSide'; // ag grid row model type
  infiniteInitialRowCount = 30; // ag grid initial row count
    cacheBlockSize: any = 30;
  maxBlocksInCache: any = 30;
  serverSideStoreType = 'partial';
  columnDefs: ColDef[]; // ag grid column defination
  public gridApi: GridApi; // ag grid api
  paginationPageSize = 30; // ag grid pagination page size
  styleChipDiv = ' flex: 1 1 auto; border: 1px solid #DFDFDF;';

  rowHeight = 38; // ag grid row height
  // Declare a variable to store grid options value
  gridOptions: GridOptions;
  // ag grid default col defination
  public defaultColDef = {
    //flex: 1,
    minWidth: 150,
    maxWidth: 400,
    sortable: true,
    resizable: true,
    filter: true,
    floatingFilter: true,
    enableRowGroup: true,
    enableValue: true,
    headerCheckboxSelection: false, // set to true for checkbox selection
    checkboxSelection: false, // set to true for checkbox selection
    rowSelection: 'multiple', // set to 'single' or 'multiple' for checkbox selection
    suppressRowClickSelection: true // if true, clicking rows doesn't select (useful for checkbox selection)
  };
  // selected user ids
  selectedUserIds = [];
  // selected user list
  selectedUsersList = [];
  // ag grid side bar defination
  public sideBar: SideBarDef | string | boolean | null = {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
      },
      {
        id: 'filters',
        labelDefault: 'Filters',
        labelKey: 'filters',
        iconKey: 'filter',
        toolPanel: 'agFiltersToolPanel',
      }
    ]
  };

  // ag grid overlay no rows template
  public overlayNoRowsTemplate =
    '<span style="font-weight: 400; color: #757575; ">No records found</span>';
  // filter options
  filterCaseOptionList = ['Approved', 'Unapproved'];
  // selected filter options
  selectedadditionalFilterValues = [];
  /** Components which is used to set on grid header */
  components: any = {
    agGridSelectAllComponent: AgGridSelectAllComponent
  };

  isShowPreferredLang = false;//show/hide preferred language column
  // bulk user actions
  bulkAccessModifyUsersSliderHeader = 'BULK_APPROVE_USER_SLIDER_TITLE\'';
  bulkAccessModifyUsersSliderOpen = false;
  userRolesList = [];
  //Job status sliderid
  bulkJobStausSliderId = 'bulkJobStausSliderId';
  // job status Header
  bulkJobStatusSliderHeader = '';
  isBulkJobSliderOpen: boolean;
  isBulkJobStatusSliderOpen: boolean;
  bulkJobStatusSliderData: any;
  // to keep slider open
  keepSliderOpen = false;
  // isSelectAll checkbox selected or not
  isSelectAll = false;
  // UnSelected users list for bulk action select all
  unSelectedUsers = [];

  // Selected user list for bulk modify access
  bulkModifySelectedUsersList = [];

  constructor(public dialog: MatDialog,//NOSONAR
    private readonly userService: UserService,
    public viewContainerRef: ViewContainerRef,
    private readonly contextMenu: MenuContextualService,
    private readonly commonService: CommonService,
    private readonly encryptService: EncryptService,
    private readonly pagerService: PagerService,
    private readonly loader: LoaderService,
    private readonly toastr: ToastrService,
    private readonly alertService: AlertService,
    public constantService: ConstantsService,
    public roleService: RoleService,
    public readonly agGridConfigurationService: AgGridConfigurationService,
    public readonly userAuthService: UserAuthService
  ) {
 
  }


  //Custom Pagination Event
  async paginate(pageNumber: number) {
    this.loading = true;
    this.loader.showSpinner.next(true);
    this.currentPage = pageNumber;
    this.pageSkipNumber = (pageNumber - 1) * this.rows;
    this.constantService.usersPerpage = this.rows;
 

    this.pager = this.pagerService.getPager(this.totalRecords, this.currentPage, this.rows);
    this.lastPage = true;
    if (this.pager.endPage === this.currentPage) {
      this.lastPage = false;
    }
    setTimeout(() => {
      if (this.dataSource) {
        this.users = this.dataSource;
        this.loading = false;
        this.loader.showSpinner.next(false);
      }
    }, 1100);
  }
  nextPaginate($event) {
    this.currentPage = $event.page;
    this.paginate(this.currentPage);
  }
  prevPaginate($event) {
    this.currentPage = $event.page;
    this.paginate(this.currentPage);
  }
  //Custom Rows Change Event
  rowsChange(rowNumber: number) {
    this.loader.showSpinner.next(true);
    this.constantService.usersPerpage = rowNumber;
    this.rows = rowNumber;
    this.pageSkipNumber = 0;
    //this.getUserDetails();
    this.currentPage = 1;
    setTimeout(() => {
      if (this.dataSource) {
        this.pager = this.pagerService.getPager(this.totalRecords, this.currentPage, this.rows);
        this.users = this.dataSource;
        this.loader.showSpinner.next(false);
      }
    }, 1000);
  }

  applyTableFilters(event: any) {
    this.jsonFilterInfo = null;
    this.jsonFilterInfo = JSON.stringify({ sortFilterinfo: event });
  }

  //Prime LazyLoad Event
  loadCarsLazy(event: TableLazyLoadEvent) {
    this.loading = true;
    this.loader.showSpinner.next(true);

    setTimeout(() => {
      if (this.dataSource) {
        this.users = this.dataSource.slice(event.first, (event.first + event.rows));
        this.loading = false;
        this.pager = this.pagerService.getPager(this.totalRecords, this.currentPage, this.rows);
        this.loader.showSpinner.next(false);

      }
    }, 1000);
  }
  changeRows(event) {
    this.rows = event;
  }
  //Pagination End
  open(event: MouseEvent, dataObject, origin, menuTemplate) {
    this.contextMenu.open(event, this.viewContainerRef, dataObject, origin, menuTemplate);
  }

  addUser(): void {
    //this.getRoles();
    this.editmode = false;
    this.enableSlider = true;
    document.getElementById('appSlider').style.width = this.constantService.sliderWidth35;
  }

  editUser(user: IdentityUserDto): IdentityUserDto {
    this.editmode = true;
    this.enableSlider = true;
    document.getElementById('appSlider').style.width = this.constantService.sliderWidth35;
    this.editRowInfo = user;
    return this.editRowInfo;
  }

  /* istanbul ignore next */
  closeNav() {
    this.searchQuery = '';
    this.showSearchButton = true;
    this.editmode = false;
    this.enableSlider = false;
    document.getElementById('appSlider').style.width = this.constantService.sliderResetWidth;
    if (this.addUserComponent) {
      this.addUserComponent.clearForm();
    }
    this.gridApi.refreshServerSide({});
  }


  ngOnInit() {
    // Set the gridOptions using the agGridConfigurationService
    this.gridOptions =
    {
      // Set the localeText property by getting the agGridConfig from the agGridConfigurationService
      localeText: this.agGridConfigurationService.getAgGridConfig()
    };

    // set default filter values
    this.selectedadditionalFilterValues = ['Approved', 'Unapproved'];

    // set column defination
    this.agGridColDef =
    {
      tableName: 'tableName',
      column:

        [
          { columnName: 'displayName', headerName: 'User name',cellStyle: 'left',  width: 15, minWidth: this.columnWidth('gridUsers', 20), maxWidth: this.columnWidth('gridUsers', 20) },
          { columnName: 'email', headerName: 'Email id', cellStyle: 'left',  width: 15, minWidth: this.columnWidth('gridUsers', 20), maxWidth: this.columnWidth('gridUsers', 20) },
          { columnName: 'status', headerName: 'Status', field: 'status', filter: 'agSetColumnFilter', cellStyle: 'left',  width: 15, minWidth: this.columnWidth('gridUsers', 20), maxWidth: this.columnWidth('gridUsers', 20) },
          { columnName: 'displayRoleNames', headerName: 'Roles', cellStyle: 'left',  width: 15, minWidth: this.columnWidth('gridUsers', 15), maxWidth: this.columnWidth('gridUsers', 15) },
          { columnName: 'updatedOn', headerName: 'Last updated', dataType: 'date', cellStyle: 'left',  width: 15, minWidth: this.columnWidth('gridUsers', 25), maxWidth: this.columnWidth('gridUsers', 15), filter: 'agDateColumnFilter' },
          { columnName: 'ACTION', headerName: 'Action', filter: false, cellStyle: 'left', width: 10, minWidth: this.columnWidth('gridUsers', 10), maxWidth: this.columnWidth('gridUsers', 15) }
        ]

    };
    this.rowModelType = 'serverSide';
    // get column defination from service
    this.columnDefs = this.agGridConfigurationService.GetUserManagementColmnDefs(this.agGridColDef);
 
    if (this.currentPage == 0)
      this.currentPage = 1;

    //this.getRoles();

  }
  columnWidth(id, percentage) {
    const div = document.getElementById(id);  // HTML ID of Grid
      const parent = div.parentElement;
      const width = parent.clientWidth * percentage / 100;  // Pixel calculation
      return width;
  }
  /* istanbul ignore next */
  rowSelected(params) {
    const selectedData = params.data;
    // check if the row is selected
    if (params.node.selected) {
      selectedData.isSelected = true;
      // push the selected user id to the selected user list
      this.selectedUserIdsdataAGGrid(selectedData);
    } else {
      selectedData.isSelected = false;
      // remove the selected user id from the selected user list
      this.selectedUserIdsdataAGGrid(selectedData);
    }
  }

  selectedUserIdsdataAGGrid(item) {
    // check if the row is selected
    if (item.isSelected) {
      // check if the selected user list already contains the user id
      if (!this.selectedUserIds.includes(item.id)) {
        this.selectedUserIds.push(item.id);
        this.selectedUsersList.push(item);
      }
    } else {
      // remove the user id from the selected user list
      this.selectedUserIds = this.selectedUserIds.filter(
        (x) => x != item.id
      );
      this.selectedUsersList = this.selectedUsersList.filter(
        (x) => x.id != item.id
      );
    }
  }

  /* istanbul ignore next */
  onClick(event: MouseEvent, dataObject, origin, menuTemplate) {
    // open context menu
    this.contextMenu.open(
      event,
      this.viewContainerRef,
      dataObject,
      origin,
      menuTemplate
    );
  }

  ngOnDestroy() {
    //this.commonService.setTenant(undefined, undefined);
  }

  onAddModifySliderClose() {
    // this.getUserDetails();
    this.gridApi.refreshServerSide({});
    this.gridApi.deselectAll();
  }

  /* istanbul ignore next */
  onUserGridReady = (params: GridReadyEvent) => {
    // get the user details
    //this.getUserDetails();    
    this.gridApi = params.api;
    this.setPageSize();
    this.gridApi.setHeaderHeight(38);
    // set filter model
    this.applyAdditionalFilter();
    const columnToolPanel = (this.gridApi.getToolPanelInstance('columns') as any) as IColumnToolPanel; //NOSONAR
    columnToolPanel.setPivotModeSectionVisible(false);
    columnToolPanel.setRowGroupsSectionVisible(false);
    columnToolPanel.setValuesSectionVisible(false);
    columnToolPanel.setPivotSectionVisible(false);
    const datasource = this.createServerSideDatasource();
    this.gridApi.setServerSideDatasource(datasource);
    this.gridApi.setSideBar(false);
  }

  setPageSize() {
    this.gridApi.paginationSetPageSize(this.paginationPageSize);
  }

  tableMenuClick(event, obj, _origin, _menuTemplate) {
    // If the event is from action column
    if (event.column.colId === 'ACTION') {
      // map the object to context menu object
      const contextObj = { extraProperties: obj, id: obj.id, title: obj.name + ' ' + obj.surname, imgTitle: null, subTitle: obj.email, statusText: obj.updatedOn, subStatusText: ' ', concurrencyStamp: obj.concurrencyStamp, status: obj.status, isRoleAssigned: obj.isRoleAssigned }
      // open context menu
      this.contextMenu.open(event.event, this.viewContainerRef, contextObj, origin, _menuTemplate);
    }
  }

  /* istanbul ignore next */
  createServerSideDatasource() {//NOSONAR

    return {
      getRows: (params) => { //NOSONAR
        if(this.roleList.length === 0) {
          this.getRoleGridData(params);
        }
        // set additional filter values
        this.setAdditionalFilterValues();
        this.loader.showSpinner.next(true);
        const filter = this.getAgGridFiler(params);
        // call the user service api to get the data
        this.userService.apiAppUserUserManagementPaginationPost(this.sortOrder, params.request.startRow, params.request.endRow, this.searchQuery, filter).subscribe({
          next: (data) => {
            const isSelectAll = this.isSelectAll;
            const unSelectedUsers = isSelectAll ? this.unSelectedUsers : [];
            this.dataSource = data.items;
            this.agGridRowData = data.items;
            this.totalRecords = data.totalCount;
            this.loader.showSpinner.next(false);
            // set the response data into ag grid
            params.success({
              rowData: data.items,
              rowCount: +data.totalCount,
            });
            if (data.items.length === 0) {
              this.gridApi.showNoRowsOverlay();
            }
            else {
              this.gridApi.hideOverlay();
            }

            // selected the rows based on the selected user ids
            const selectedUserIds = this.selectedUserIds;

            // deselect all the rows
            this.selectedUserIds = [];
            // set the selected user list to empty
            this.selectedUsersList = [];
            // select the rows based on the selected user ids
            this.gridApi.deselectAll();

            // select the rows based on the selected user ids
            this.gridApi.forEachNode(function (node) {
              // check if node is not null and node has data
              if (node && node.data) {
                // check if the selected user ids contains the user id
                if ((selectedUserIds.indexOf(node.data?.id) > -1 || isSelectAll) && unSelectedUsers.indexOf(node.data?.id) === -1) {
                  node.setSelected(true);
                } else {
                  node.setSelected(false);
                }
              }
            });
            this.unSelectedUsers = isSelectAll ? this.getUnSelectedUsers() : [];
          },
          error: (_error) => {
            // on error set the ag grid row data to empty
            params.success({
              rowData: [],
              rowCount: 0
            });
            this.gridApi.showNoRowsOverlay();
            // on error show the error message
            // this.toastr.error(this.translate.getTranslation("OPPORTUNITY.ERROR"), null, {
            //   toastClass: "error",
            // });
          }

        });
      },
    };
  }

  /* istanbul ignore next */
  private generateFilter(fieldName, filterModel) {
    if (filterModel.filterType === 'set') {
      return {
        fieldName: fieldName,
        searchKey: filterModel.values.join(','),
        matchMode: 'equals'
      };
    } else if (filterModel.filterType === 'date') {
      return {
        fieldName: fieldName,
        operator: filterModel.operator,
        matchMode: filterModel.conditions ? filterModel.conditions[0].type : filterModel.type,
        searchKey: this.createDateSearchKey(
          filterModel.conditions ? filterModel.conditions[0] : null,
          filterModel.conditions ? filterModel.conditions[1] : null,
          filterModel.dateFrom,
          filterModel.dateTo
        )
      };
    } else {
      return {
        fieldName: fieldName,
        operator: filterModel.operator,
        matchMode: filterModel.conditions ? filterModel.conditions[0].type : filterModel.type,
        searchKey: filterModel.conditions ? `${filterModel.conditions[0].filter},${filterModel.conditions[1].filter}` : filterModel.filter
      };
    }
  }

  /* istanbul ignore next */
  private createDateSearchKey(condition1, condition2, dateFrom, dateTo) {
    // If condition1 is truthy
    if (condition1) {
      return this.createDateSearchKeyFromCondition(condition1, condition2);
    } else {
      // If condition1 is falsy
      let result = dateFrom;

      if (dateTo) {
        result += `, ${dateTo}`;
      }

      // Check if condition2 and condition2.dateTo are truthy
      if (condition2 && condition2.dateTo) {
        // Append condition2.dateFrom and condition2.dateTo to the result
        result += `, ${condition2.dateFrom}, ${condition2.dateTo}`;
      }

      // Return the final result
      return result;
    }
  }

  /* istanbul ignore next */
  private createDateSearchKeyFromCondition(condition1, condition2) {
    let firstDatePart;

    // Check if condition1.dateTo is truthy
    if (condition1.dateTo) {
      firstDatePart = `${condition1.dateFrom}, ${condition1.dateTo}`;
    } else {
      firstDatePart = condition1.dateFrom;
    }

    let secondDatePart = '';

    // Check if condition2 is truthy
    if (condition2) {
      // Check if condition2.dateTo is truthy
      if (condition2.dateTo) {
        secondDatePart = `${condition2.dateFrom}, ${condition2.dateTo}`;
      } else {
        secondDatePart = condition2.dateFrom;
      }
    }

    // Combine the first and second date parts
    if (secondDatePart) {
      return `${firstDatePart}, ${secondDatePart}`;
    }

    return `${firstDatePart}`;
  }

  /* istanbul ignore next */
  private getAgGridFiler(params) {
    // Disable the add button when the grid is loading
    let filter;
    let filterArray;

    // Check if filterModel is not empty
    if (Object.keys(params.request.filterModel).length > 0) {
      // Create an array of filters based on the filterModel
      filterArray = Object.keys(params.request.filterModel).map(fieldName =>
        this.generateFilter(fieldName, params.request.filterModel[fieldName])
      );
    }

    // Check if sortModel is not empty or if filterArray is defined
    if (params.request.sortModel.length > 0 || filterArray) {
      // Set sortCol and sortOrder
      const sortCol = params.request.sortModel.length > 0 ? params.request.sortModel[0].colId : null;
      // Set sortOrder
      const sortOrder = params.request.sortModel.length > 0 ? params.request.sortModel[0].sort : null;
      // Set filter json
      filter = JSON.stringify({
        sortFilterinfo: {
          filters: filterArray || [],  // Use filterArray if it is defined, otherwise, use an empty array
          sortCol: sortCol,
          sortOrder: sortOrder || 'asc'  // Default sortOrder to 'asc' if not specified
        }
      });
    }
    return filter;
  }

  /* istanbul ignore next */
  applyAdditionalFilter() {
    // default filter to be applied
    const defaultFilter = {
      status: {
        // default filter approved and unapproved
        values: this.selectedadditionalFilterValues,
        filterType: 'set'
      }
    }
    // set filter model
    this.gridApi.setFilterModel(defaultFilter);
  }

  /* istanbul ignore next */
  setAdditionalFilterValues() {
    // if filter model have status filter then set the selectedadditionalFilterValues else set default filter
    if (this.gridApi.getFilterModel()['status']) {
      this.selectedadditionalFilterValues = this.gridApi.getFilterModel()['status'].values;
    }
    else {
      this.selectedadditionalFilterValues = ['Approved', 'Unapproved'];
    }
  }

  /* istanbul ignore next */
  cancelAdditionalFilterChipAGGrid(value) {
    // updated selectedadditionalFilterValues
    this.selectedadditionalFilterValues = this.selectedadditionalFilterValues.filter(item => item !== value);
    // apply filter
    this.applyAdditionalFilter();
  }

  /* istanbul ignore next */
  selectionChanged(params) {
    // Check if isSelectAll and isChecked are present in the params
    if ('isSelectAll' in params && 'isChecked' in params) {
      this.isSelectAll = params.isSelectAll;
      // Loop through each row
      this.gridApi.forEachNode((node) => {
        // Set the selected state of the row
        node.setSelected(params.isChecked);
        // Update the selected user list
        this.selectedUserIdsdataAGGrid(node.data);
      });
    }
    this.unSelectedUsers = this.isSelectAll ? this.getUnSelectedUsers() : [];
  }

  /* istanbul ignore next */
  getUnSelectedUsers() {
    const unSelectedUsers = [];
    this.gridApi.forEachNode((node) => {
      if (!node.isSelected() && node.data?.id) {
        unSelectedUsers.push(node.data.id);
      }
    });
    return unSelectedUsers;
  }

  onFilterChanged() {
    this.isSelectAll = false;
    this.gridApi.deselectAll();
    this.gridApi.refreshServerSide();
  }

  // BIND GRID WITH API DATA
  noop() { } // no-operation empty event 

  getRoleGridData(params) {
    params.request.filterModel['isactive'] = {
      'filterType': 'text',
      'type': 'contains',
      'filter': 'true'
    };
    this.roleService.apiAppRoleRolesPost(params.request).subscribe({
      next: (res) => {
        if (res && res.items.length > 0) {
          this.roleList = res.items;
          for (const element of this.roleList) {
            element.checked = false;
          }
        }
      },
      error: (err) => {
      },
      complete: () => {
      }
    });

  }
  setUserStatus(user, status) {
    let confrimMessage = '';
    let toastMsg = '';
    let buttonText = '';
    // if status is true then set the message
    if (status) {
      confrimMessage = 'Are you sure you want to approve user access?';
      toastMsg = 'User access approved.';
      buttonText = 'Yes, Approve';
    }
    else {
      confrimMessage = 'Are you sure you want to unapprove user access?';
      toastMsg = 'User unapproved successfully';
      buttonText = 'Yes, Unapprove!'
    }
    this.alertService.buildDialog().fire({
      title: 'Are you sure?',
      text: confrimMessage,
      icon: this.alertService.WarningIcon,
      showCancelButton: true,
      confirmButtonText: buttonText,
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        this.userService.apiAppUserIdSetActiveInactivePost(user.id, status)
          .subscribe({
            next: (res) => {
              if(res.status === true) {
              this.toastr.success(toastMsg, '');
              this.gridApi.refreshServerSide({});
              }
              else{
                  this.alertService.buildDialog().fire({
                  title: 'Error!',
                  text:res.message,
                  icon: this.alertService.ErrorIcon,
                  showCancelButton: false,
                  confirmButtonText: 'OK',
                  cancelButtonText: '',
                });
              }
            },
            error: (error) => {
                this.alertService.buildDialog().fire({
                title: 'You cannot deactivate this user!',
                  text:error.error.error.message,
                  icon: this.alertService.ErrorIcon,
                  showCancelButton: false,
                  confirmButtonText: 'OK',
                  cancelButtonText: '',
                });
              
              this.gridApi.refreshServerSide({});
            }
          });
      }
    });
  }

  deleteDialog(user) {
    this.alertService.buildDialog().fire({
      title: 'Are you sure?',
      text: 'You want to remove the User?',
      icon: this.alertService.WarningIcon,
      showCancelButton: true,
      confirmButtonText: 'Yes, Remove!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        this.userService.apiAppUserIdDelete(user.id).subscribe({
          next: (res) => {
            if (res == this.constantService.success) {

              let toastMsg = '';
              toastMsg = 'User removed successfully';
              this.toastr.success(toastMsg, '');
              this.gridApi.refreshServerSide({});

            } else if (res == this.constantService.invaliduser) {
              this.alertService.buildDialog().fire({
                title: 'Error',
                text: 'User not found',
                icon: this.alertService.ErrorIcon,
                showCancelButton: false,
                confirmButtonText: 'OK',
                cancelButtonText: '',
              });

            } else {
              this.alertService.buildDialog().fire({
                title: 'Error',
                text: 'Failed to delete User',
                icon: this.alertService.ErrorIcon,
                showCancelButton: false,
                confirmButtonText: 'OK',
                cancelButtonText: '',
              });
            }
          },
          error: (_error) => {

            this.alertService.buildDialog().fire({
              title: 'Error',
              text: 'An error occurred',
              icon: this.alertService.ErrorIcon,
              showCancelButton: false,
              confirmButtonText: 'OK',
              cancelButtonText: '',
            });

          }
        });
      }
    });
  }


}
